import React from "react";
import style from '../Imagen/imagen.module.css';

const Imagen = () => {
    return (
        <div className={style.containerImagen}>
            <div className={style.aboutImage}>
                <img src={process.env.PUBLIC_URL + '/nahuel.jpg'} alt="Mi foto" />
            </div>
        </div>
    );
};

export default Imagen;

